module.exports = __webpack_public_path__ + "img/sld_scb_16_t1_b1.14a68b0a.svg";